import { render, staticRenderFns } from "./ProviderNotif.vue?vue&type=template&id=432bcb49&"
import script from "./ProviderNotif.vue?vue&type=script&lang=ts&"
export * from "./ProviderNotif.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports